import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { dateParser, enumParser, PartnerOrganizationMemberRole, PartnerOrganizationMemberStatus, } from '#validation';
import { paginatedResponse } from '#web-service-api/common';
export const PartnerOrganizationMemberResponseSchema = z.object({
    id: z.number(),
    partnerOrganizationId: z.string(),
    accountId: z.string(),
    role: enumParser(PartnerOrganizationMemberRole),
    status: enumParser(PartnerOrganizationMemberStatus),
    phone: z.string().nullable(),
    email: z.string(),
    jobTitle: z.string().nullable(),
    createdAt: dateParser(),
    updatedAt: dateParser(),
});
export class PartnerOrganizationMemberResponseDto extends createZodDto(PartnerOrganizationMemberResponseSchema) {
}
const partnerOrganizationMemberListResponseSchema = paginatedResponse(PartnerOrganizationMemberResponseSchema);
export class PartnerOrganizationMemberListResponseDto extends createZodDto(partnerOrganizationMemberListResponseSchema) {
}
